const NAVER_MAP_WEB = 'https://map.naver.com';
const KAKAO_MAP_WEB = 'https://map.kakao.com/link/map';

/** @description 네이버 맵을 위경도로 여는 유틸 함수 (name은 마커 라벨로 사용) */
export const openNaverMap = (latitude: number, longitude: number, name: string) => {
  const safeName = name.replaceAll(',', '');
  const params = new URLSearchParams({
    lng: String(longitude),
    lat: String(latitude),
    title: safeName,
  });
  window.open(`${NAVER_MAP_WEB}/?${params.toString()}`, '_blank');
};

/** @description 카카오 맵을 위경도로 여는 유틸 함수 (name은 마커 라벨로 사용) */
export const openKakaoMap = (latitude: number, longitude: number, name: string) => {
  // 카카오 link/map은 콤마를 구분자로 사용하므로 name 내부의 콤마는 제거
  const safeName = name.replaceAll(',', '');
  window.open(`${KAKAO_MAP_WEB}/${safeName},${latitude},${longitude}`, '_blank');
};
